import { useCallback, useState } from 'react';
import { SketchPicker, } from 'react-color';
import { Loading } from '../../components/Loading';
import { useInfiniteQuery } from "@tanstack/react-query";
import Api from 'utils/api/Api';

const BackgroundTool = ({canvas, className='left'})=>{
    const [keyword, setKeyword] = useState('');

    const { data:backgroundList, fetchNextPage, hasNextPage, isLoading } = useInfiniteQuery({
        queryKey:['picture/background', 'page', keyword],
        queryFn:async({pageParam=0})=>{
            const promise = await Api.get(`/api/clipart/background/list?page=${pageParam}&keyword=${encodeURI(keyword)}`);
            return promise.data;
        },
        getNextPageParam:(lastPage, allPosts)=>{
            return (lastPage.page+1) !== allPosts[0].totalPages ? lastPage.page + 1 : undefined;
        }
    });

    const [backgroundColor, setBackgroundColor] = useState('#fff');
    const [backgroundImage, setBackgroundImage] = useState(null);
    const [colorPickerVisible, setColorPickerVisible] = useState(false);
    

    const setBackground = useCallback((background)=>{
        // const img = event.target;
        // let url = img.src;
        let url = background.url;
        if( undefined!==url && null!==url && url!=='' ){
            canvas.setBackgroundImage(url, canvas.renderAll.bind(canvas), {
                backgroundImageOpacity: 1
                ,backgroundImageStretch: false
                // ,crossOrigin: 'anonymous'
            });
            setBackgroundImage(true);
        }else{
            canvas.setBackgroundImage(null);
            canvas.renderAll();
            setBackgroundImage(false);
        }
    }, [canvas]);


    const onChangeColor = useCallback((color)=>{
        setBackgroundColor(color.hex);
        canvas.backgroundColor = color.hex;
        canvas.renderAll();
    }, [canvas]);
    
    
    return (
        <div className="backgroundContainer">
            <div className="controls text-center">
                <div className="btn colorPickerbutton" onClick={e=>setColorPickerVisible(!colorPickerVisible) }>
                    <div className="color" style={ {background:backgroundColor} } ></div>
                </div>
                { colorPickerVisible && <div className="colorPickerPopover"><SketchPicker color={ backgroundColor } onChangeComplete={onChangeColor} /> </div>}
                <button className="btn _xsm _red" disabled={!backgroundImage} onClick={setBackground}>배경삭제</button>
                <br />
                
                
                <button className={`btn _xsm _tab ${keyword==='편지지'?'on':''}`} onClick={e=>setKeyword('편지지')} >편지지</button>
                <button className={`btn _xsm _tab ${keyword==='자연'?'on':''}`} onClick={e=>setKeyword('자연')} >자연</button>
                <button className={`btn _xsm _tab ${keyword==='도시'?'on':''}`} onClick={e=>setKeyword('도시')} >도시</button>
                <button className={`btn _xsm _tab ${keyword==='기타'?'on':''}`} onClick={e=>setKeyword('기타')} >기타</button>
            </div>
            
            
            <div className="listContainer">
                <div className="list">
                    {backgroundList?.pages?.map(pb=>{
                        return pb?.list.map(bg=>{
                            return (<img src={bg.thumbnail} alt="" className="background rounded"
                                    onClick={()=>{setBackground(bg)} } key={bg.id} />   
                            );
                        });
                    })}
                    {isLoading && <Loading /> }
                    { hasNextPage && <button className="btn _xsm _blue" onClick={()=>fetchNextPage()}>더 보기</button>}
                </div>
            </div>
        </div>
    );
}
export default BackgroundTool;